import { giphyDarkCharcoal, giphyDarkestGrey, giphyLightCharcoal, giphyLightGrey, giphyWhite } from '@giphy/js-brand'
import styled from 'styled-components'
import { grid12 } from 'shared/util/grid'

const otherGrey = `rgba(0, 0, 0, 0.25)`

// TODO these heights are arbitrary
export const Container = styled.div`
    display: flex;
    flex-direction: column;
    background: ${giphyDarkestGrey};
    padding: 10px 26px;
    width: 780px;
    min-height: 442px;
    -webkit-font-smoothing: antialiased;
`

export const DisableModal = styled.div`
    background: black;
    opacity: 0.4;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
`
export const GifSelectorContainer = styled(Container)`
    width: ${grid12 + 60}px;
    height: 650px;
    max-width: inherit;
    max-height: inherit;
    padding-bottom: 0;
`

export const Copy = styled.div`
    font-family: 'interface', Helvetica Neue, helvetica, sans-serif;
    color: ${giphyLightGrey};
`

export const Label = styled(Copy)`
    font-family: 'interface', Helvetica Neue, helvetica, sans-serif;
    font-weight: 600;
    color: ${giphyLightGrey};
    font-size: 14px;
    margin-bottom: 4px;
`

export const Optional = styled(Label)`
    color: ${giphyDarkCharcoal};
    font-size: 12px;
`

export const Section = styled.div`
    margin-top: 30px;
`

export const Input = styled.input`
    display: flex;
    width: 100%;
    box-sizing: border-box;
    background: ${otherGrey};
    cursor: text;
    color: inherit;
    resize: none;
    -webkit-appearance: none;
    border-width: 0;
    border-style: initial;
    border-color: initial;
    border-image: initial;
    padding: 20px;
    position: relative;
    ::placeholder {
        color: ${giphyLightCharcoal};
    }
    color: ${giphyWhite};
`

export const NameField = styled(Input)`
    font-family: 'nexablack', sans-serif;
    font-size: 28px;
    padding: 35px 20px;
`

export const DescriptionField = styled(Input)`
    font-family: 'interface', Helvetica Neue, helvetica, sans-serif;
    font-size: 15px;
    min-height: 115px;
`
